function agreementReadMoreButton(agreementEl, readMoreAgreementEl) {
    const readMoreBtn = agreementEl.querySelector('.influencer-agreement-form__read-more-btn');
    readMoreBtn.classList.add('influencer-agreement-form__read-more-btn-unhide');
    readMoreBtn.addEventListener('click', function () {
        const dataExpanded = JSON.parse(readMoreBtn.dataset.expanded);
        if (dataExpanded) {
            readMoreBtn.dataset.expanded = !dataExpanded;
            readMoreAgreementEl.classList.remove('influencer-agreement-more-text--unhide');
            readMoreBtn.textContent = readMoreBtn.dataset.readMoreTxt;
        } else {
            readMoreBtn.dataset.expanded = !dataExpanded;
            readMoreAgreementEl.classList.add('influencer-agreement-more-text--unhide');
            readMoreBtn.textContent = readMoreBtn.dataset.readLessTxt;
        }
    })
}

function printAgreement(containerEl, agreementEl, printAgreementBtn, readMoreAgreementEl) {
    printAgreementBtn.addEventListener('click', function () {
        const title = containerEl.dataset.title || 'Agreement';
        const printCSS = containerEl.dataset.printAgreementFormCss;

        const oldIframe = document.getElementById('print-agreement-iframe');
        if (oldIframe) oldIframe.remove();

        const iframe = document.createElement('iframe');
        iframe.id = 'print-agreement-iframe';
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        document.body.appendChild(iframe);

        const doc = iframe.contentDocument || iframe.contentWindow.document;

        doc.open();
        doc.write(`
                <html>
                    <head>
                        <title>${title}</title>
                        <link rel="stylesheet" href="${printCSS}">
                    </head>
                    <body></body>
                </html>
            `);
        doc.close();

        iframe.onload = () => {
            const contentClone = containerEl.parentElement.cloneNode(true);

            // Get saved form data
            let formData = {};
            let validData = true;

            try {
                const savedData = sessionStorage.getItem('influencerAgreementFormData');
                formData = savedData ? JSON.parse(savedData) : {};
                if (!savedData || Object.keys(formData).length === 0) validData = false;
            } catch (e) {
                validData = false;
            }

            // Fill inputs with values from session storage, or leave blank
            const inputs = contentClone.querySelectorAll('input, textarea, select');
            inputs.forEach(input => {
                const name = input.getAttribute('name') || input.id || '';
                const key = name.replace(/^influencerAgreementForm/, '').toLowerCase();
                const value = formData[key] || '';
                input.value = value;
            });

            iframe.contentDocument.body.appendChild(contentClone);

            // Trigger print dialog after content is loaded
            setTimeout(() => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();

                setTimeout(() => {
                    iframe.remove();
                }, 1000);
            }, 300);

        }
    });
}

function saveFormDataToGoogleSheet(containerEl, printAgreementBtn, readMoreAgreementEl) {
    const formEl = containerEl.querySelector('#InfluencerAgreementForm');
    if (!formEl) return;

    formEl.addEventListener('submit', function (e) {
        e.preventDefault();

        const name = document.getElementById('influencerAgreementFormName').value.trim();
        const username = document.getElementById('influencerAgreementFormUsername').value.trim();
        const email = document.getElementById('influencerAgreementFormMail').value.trim();
        const phone = document.getElementById('influencerAgreementFormPhone').value.trim();
        const submitBtn = formEl.querySelector('.influencer-agreement-form__submit-btn');
        const submitBtnSuccessImg = containerEl.querySelector('.influencer-agreement-form__submit-btn-img')?.cloneNode(true);

        if(submitBtn.textContent === "Submitting..."){
            alert("Your agreement is currently being submitted. Please wait a moment before trying again.");
            return;  
        }else if(submitBtn.textContent === submitBtn.dataset.successTxt){
            alert("Your agreement has already been submitted. Please try again later.");
            return;  
        }

        submitBtn.textContent = "Submitting...";

        // Email Validation
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/;
        const isGmailOrEmail = emailPattern.test(email);

        // Instagram username validation.
        const usernameRegex = /^[a-zA-Z0-9._]{1,30}$/;

        // Phone Validation (India: starts with 6/7/8/9 and 10 digits)
        const phonePattern = /^[6-9]\d{9}$/;
        const isValidPhone = phonePattern.test(phone) && !/^(\d)\1{9}$/.test(phone);

        // Show errors if validation fails
        if (!name) {
            alert('Please enter your name.');
            submitBtn.textContent = submitBtn.dataset.text;
            return;
        }

        if (!username) {
            alert('Please enter your Instagram username.');
            submitBtn.textContent = submitBtn.dataset.text;
            return;
        }else if(!usernameRegex.test(username)){
            alert('Invalid Instagram username. It should only contain letters, numbers, underscores, and periods, and be between 1 and 30 characters.');
            submitBtn.textContent = submitBtn.dataset.text;
            return;
        }

        if (!isGmailOrEmail) {
            alert('Please enter a valid email address.');
            submitBtn.textContent = submitBtn.dataset.text;
            return;
        }

        if (!isValidPhone) {
            alert('Please enter a valid 10-digit Indian mobile number starting with 6, 7, 8, or 9.');
            submitBtn.textContent = submitBtn.dataset.text;
            return;
        }

        const data = {
            name,
            username,
            email,
            phone,
        };

        // TO HANDLE ERROR
        function errorHandler(){
            alert('Something went wrong. Please try again later.');
            submitBtn.textContent = submitBtn.dataset.text;
        }
        const errorAltertTimerId = setTimeout(errorHandler, 30000);

        // TO REVERT THE SUBMIT BTN TEXT
        function sucessHandler(){
            submitBtn.textContent = submitBtn.dataset.text;
            if(submitBtnSuccessImg?.parentNode){
                submitBtnSuccessImg.classList.add('hidden');
                submitBtnSuccessImg.parentNode.removeChild(submitBtnSuccessImg);
            }
            submitBtnSuccessImg?.classList.add('hidden');
        }

        const scriptURL = 'https://script.google.com/macros/s/AKfycbzHtYGzj0d1v6gfmjuHKDClVy04egfkt4xWHXxugrz6aPChlQszM7o7mRzZ0eIwBxytvA/exec';
        fetch(scriptURL, {
            method: 'POST',
            body: JSON.stringify(data),
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(() => {
            clearTimeout(errorAltertTimerId);
            sessionStorage.setItem('influencerAgreementFormData', JSON.stringify(data));
            formEl.reset();
            submitBtn.textContent = submitBtn.dataset.successTxt;
            if(submitBtnSuccessImg){
                submitBtnSuccessImg.classList.remove('hidden');
                submitBtn.appendChild(submitBtnSuccessImg);
            } 
            printAgreementBtn?.click();
            setTimeout(sucessHandler, 10000);
        });

    });
}

function initiateAgreementFormAction() {
    const containerEl = document.getElementById('AgreementForm');
    if (!containerEl) return;

    const agreementEl = containerEl.querySelector('#Agreement');
    if (agreementEl?.innerHTML.includes('[READMORE]')) {
        const parts = agreementEl.innerHTML.split('[READMORE]');
        agreementEl.innerHTML = `
            ${parts[0].trim()}
            <span id="influencer-agreement-more-text">${parts[1].trim()}</span>
        `;
    }
    const readMoreAgreementEl = agreementEl.querySelector('#influencer-agreement-more-text');
    if (readMoreAgreementEl) agreementReadMoreButton(agreementEl, readMoreAgreementEl);

    const printAgreementBtn = containerEl.querySelector(".influencer-agreement-form__print-btn");
    if(printAgreementBtn){
        if (JSON.parse(printAgreementBtn.dataset.printEnabled)) printAgreement(containerEl, agreementEl, printAgreementBtn, readMoreAgreementEl);
    }

    saveFormDataToGoogleSheet(containerEl, printAgreementBtn, readMoreAgreementEl);
}


document.addEventListener("DOMContentLoaded", initiateAgreementFormAction)


